module.exports = __webpack_public_path__ + "static/media/46.a326a263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/46.jpg
// module id = 306
// module chunks = 0